import { pickTransparentVariationUrl } from '@sparemin/embed-config';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { makeVideoSelector } from 'redux/modules/entities';
import { IVideoClip } from 'types';
import { getSupportsWebmAlphaSync } from 'utils/supports-webm-alpha';

/**
 * Resolves the URL to render for a video clip in an embed configuration. If
 * the clip's upload has an eligible transparent variation for the current
 * browser, that URL is returned; otherwise falls back to the clip's stored
 * `videoUrl`. Returns `undefined` only when the clip itself is undefined.
 */
const useVideoPlaybackUrl = (
  clip: Pick<IVideoClip, 'videoId' | 'videoUrl'> | undefined,
): string | undefined => {
  const videoSelector = useMemo(
    () => makeVideoSelector(clip?.videoId as number),
    [clip?.videoId],
  );
  const upload = useSelector(videoSelector);

  const picked = pickTransparentVariationUrl(
    upload?.variations,
    getSupportsWebmAlphaSync(),
  );

  return picked ?? clip?.videoUrl;
};

export default useVideoPlaybackUrl;
